import React, { Component } from 'react'
import axiosraw from 'axios'
import utils from '~/utils/TemplateEditor/dragDropFunctions.jsx';

export default class ComponentVimeoVideo extends Component {
    constructor(props) {
        super(props)

        this.change = this.change.bind(this);
        this.grabVideoThumb = this.grabVideoThumb.bind(this);
    }

    grabVideoThumb(vidId, origVal) {
        var url = "https://vimeo.com/api/v2/video/" + vidId + ".json";
        axiosraw.get(url).then(vidData => {

            vidData = vidData.data[0]
            var thumb = vidData.thumbnail_large ? vidData.thumbnail_large : vidData.thumbnail_medium ? vidData.thumbnail_medium : vidData.thumbnail_small ? vidData.thumbnail_small : ""

            return utils.getVideoThumb(this.props.templateId, thumb).then(response => {
                this.props.updateVal(this.props.path, { value: origVal, thumbUrl: response.data.url });
            })
        }).catch(err => {
            console.log(err);
        });

    }
    change(event) {

        var thisVal = event.currentTarget.value;
        this.props.updateVal(this.props.path, { value: thisVal, thumbUrl: "" });
        if (thisVal.toLowerCase().indexOf("vimeo.com") == -1) {
            this.props.updateVal(this.props.path, { value: thisVal, thumbUrl: "" });
            return;
        }

        var vidUrl = thisVal.split(/\//g);
        var vidId = vidUrl[vidUrl.length - 1].split("?")[0].split("/")[0];
        if (isNaN(vidId) || vidId == "") {
            this.props.updateVal(this.props.path, { value: thisVal, thumbUrl: "" });
            return;
        }
        this.grabVideoThumb(vidId, thisVal)

    }

    render() {
        var style = {};
        if (this.props.elementData.optionFullWidth) style = { flex: "100%" }

        var errorText = "";
        if (this.props.value.toLowerCase().indexOf("vimeo.com") == -1) {
            errorText = "Please enter a valid vimeo video url (ie https://vimeo.com/video_id)"
        } else {
            var vidUrl = this.props.value.split(/\//g);
            var vidId = vidUrl[vidUrl.length - 1].split("?")[0].split("/")[0];
            if (isNaN(vidId) || vidId == "") {
                errorText = "Please enter a valid vimeo video url (ie https://vimeo.com/video_id)"
            }
        }

        return <div className="dndEditorv2-dd_toolHolder" style={style}>
            <div className="dd_inputTool">
                <p className="txtInput_label">{this.props.title}</p>
                <div className="dndEditorv2-inputWrapper">
                    <input value={this.props.value} onChange={this.change} placeholder={this.props.title} />
                    {(errorText.length > 0) && <div style={{ fontSize: "12px", color: "red" }}>{errorText}</div>}
                </div>
            </div>
        </div>

    }
}


